import Vue from "vue";
import VueToastr from "@deveodk/vue-toastr";
import App from "./App.vue";
import VueTreeList from "vue-tree-list";

import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "./assets/base.scss";

import "@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css";

Vue.config.productionTip = false;

Vue.use(VueToastr, {
  defaultPosition: "toast-bottom-right",
  defaultType: "info",
  defaultTimeout: 3000
});

Vue.use(VueTreeList);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
